import { render, staticRenderFns } from "./ModalStructureDelete.vue?vue&type=template&id=5cb8d0ab&"
import script from "./ModalStructureDelete.vue?vue&type=script&lang=js&"
export * from "./ModalStructureDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalStructureDelete.vue?vue&type=style&index=0&id=5cb8d0ab&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports